// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__UlEek","sendOtp":"AuthorizeToLogin_sendOtp__1k2uQ"};